import PropTypes from 'prop-types';

import { getWebEnv } from '@/utils/helper';

import Icon from '@/atoms/Icon/Icon';
import Text from '@/atoms/Text/Text';

import RichText from '@/molecules/RichText/RichText';

export default function QuestionItem({
  index,
  answer,
  id,
  isOpen,
  question,
  toggleQuestion,
  entries,
}) {
  return (
    <div
      className="aaco-faq__question flex flex-col dd-kr:border-b dd-en:border-b dd-kr:border-light-grey-1 dd-en:border-light-grey-1"
      id={id}
      onClick={(e) => toggleQuestion(e, id, question)}
      role="button"
    >
      <div
        className={`aaco-faq__question__title ${
          isOpen ? 'opened' : 'closed'
        } py-4 w-full flex justify-between border-b border-wf-mid-grey items-center dd-kr:uppercase dd-en:uppercase dd-kr:border-b-0 dd-en:border-b-0 dd-kr:py-[19px] dd-en:py-[19px] dd-kr:md:pt-[26px] dd-en:md:pt-[26px] dd-kr:md:pb-[27px] dd-en:md:pb-[27px] dd-kr:border-light-grey-1 dd-en:border-light-grey-1 ${
          index === 0 ? 'dd-kr:border-t dd-en:border-t' : ''
        }`}
      >
        <Text
          style={
            'dd-kr:text-progressive-blue dd-en:text-progressive-blue dd-kr:text-body-large-bold dd-en:text-body-large-bold dd-kr:font-body-large-bold dd-en:font-body-large-bold dd-kr:font-text dd-en:font-text'
          }
        >
          {question}
        </Text>
        <Icon
          className={`ml-1.5 transition-transform duration-200 dd-kr:text-actual-dd-gold dd-en:text-actual-dd-gold ${
            isOpen && 'rotate-180'
          }`}
          height={getWebEnv() === 'wh' ? 3.94 : 9}
          name="chevron-down"
          width={getWebEnv() === 'wh' ? 7.88 : 9}
        />
      </div>
      {answer?.content?.length > 0 &&
        answer.content.map(({ nodeType, content }, index) => (
          <div
            className={`aaco-faq__question__description ${
              isOpen
                ? 'block pb-2 dd-kr:pb-[23px] dd-en:pb-[23px] dd-kr:md:pb-6 dd-en:md:pb-6'
                : 'hidden'
            }`}
            key={index}
          >
            <RichText
              entries={entries}
              content={content}
              nodeType={nodeType}
              richTextStyle={{
                paragraph: {
                  customFont:
                    'font-text font-body text-body text-black dd-kr:text-body-text-grey dd-en:text-body-text-grey',
                  paragraphWrapper: 'py-3 dd-kr:py-0 dd-en:py-0',
                },
                list: {
                  li: 'pl-4 mb-7',
                  ol: 'pl-6',
                },
              }}
            />
          </div>
        ))}
    </div>
  );
}

QuestionItem.propTypes = {
  answer: PropTypes.object,
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  question: PropTypes.string,
  toggleQuestion: PropTypes.func,
};
